/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Invalid/view.blocks to change it.
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Invalid({
  children,
  viewPath = "/App/Form/Data/ProvideData/ResponsiblePersonEmail/Status/Invalid"
  
}) {
  return null
}